
import { UPDATE_DATA }  from '../constants';
const defaultState = { 
   
  };

export const articeluploaded = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {       
        case UPDATE_DATA:
            return {
                ...state,
                ...payload,
            };        
        default:
            return state;
    }
};
